import { Link } from 'react-router-dom';
import { articles } from '@/mocks/kunlun-data';

const articleImages: Record<string, string> = {
  'article-glacier-health': 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20photography%20of%20pure%20glacier%20water%20in%20a%20transparent%20glass%20on%20a%20clean%20white%20surface%20with%20natural%20sunlight%2C%20minimalist%20lifestyle%20aesthetic%2C%20soft%20shadows%2C%20premium%20wellness%20brand%20feel%2C%20calm%20and%20serene%20atmosphere&width=600&height=400&seq=article-glacier-health&orientation=landscape',
  'article-brand-story': 'https://readdy.ai/api/search-image?query=Majestic%20Kunlun%20mountain%20range%20with%20ancient%20glaciers%20under%20golden%20sunrise%20light%2C%20pristine%20snow%20covered%20peaks%2C%20ethereal%20mist%20in%20deep%20valleys%2C%20cinematic%20aerial%20landscape%20photography%2C%20grand%20and%20breathtaking%20natural%20scenery&width=600&height=400&seq=article-brand-story&orientation=landscape',
  'article-guide': 'https://readdy.ai/api/search-image?query=A%20collection%20of%20different%20premium%20mineral%20water%20bottles%20arranged%20elegantly%20on%20a%20white%20marble%20surface%20with%20natural%20lighting%2C%20lifestyle%20product%20photography%2C%20clean%20minimalist%20composition%2C%20sophisticated%20aesthetic&width=600&height=400&seq=article-guide&orientation=landscape',
  'article-culture': 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20style%20depicting%20the%20sacred%20Kunlun%20mountains%20with%20flowing%20waterfalls%20and%20ancient%20pine%20trees%2C%20misty%20atmosphere%2C%20ethereal%20and%20spiritual%20aesthetic%2C%20artistic%20rendering&width=600&height=400&seq=article-culture&orientation=landscape',
  'article-compare': 'https://readdy.ai/api/search-image?query=Two%20glasses%20of%20water%20side%20by%20side%20on%20a%20minimal%20white%20table%2C%20one%20with%20glacier%20ice%20cubes%20and%20the%20other%20regular%2C%20scientific%20comparison%20aesthetic%2C%20clean%20laboratory%20style%20lighting%2C%20precise%20and%20clinical%20feel&width=600&height=400&seq=article-compare&orientation=landscape',
  'article-awards': 'https://readdy.ai/api/search-image?query=A%20premium%20mineral%20water%20bottle%20next%20to%20three%20golden%20award%20medals%20on%20a%20white%20pedestal%20with%20dramatic%20spotlight%20lighting%2C%20prestigious%20awards%20ceremony%20feel%2C%20elegant%20and%20celebratory%20atmosphere&width=600&height=400&seq=article-awards&orientation=landscape',
};

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase font-heading">
              ARTICLES
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3">
              最新文章
            </h2>
          </div>
          <Link
            to="/articles"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-[10px] text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <span className="text-[11px] text-foreground-400">{article.readTime} 阅读</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}